export default __webpack_public_path__ + "static/media/left_bottom_new.7ad3508d.png";